import { render, staticRenderFns } from "./MessageContentText.vue?vue&type=template&id=4a8cfb19&scoped=true"
import script from "./MessageContentText.vue?vue&type=script&lang=js"
export * from "./MessageContentText.vue?vue&type=script&lang=js"
import style0 from "./MessageContentText.vue?vue&type=style&index=0&id=4a8cfb19&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8cfb19",
  null
  
)

export default component.exports